import { render, staticRenderFns } from "./AddOrEditProviderModal.vue?vue&type=template&id=22fa57f1&scoped=true&"
import script from "./AddOrEditProviderModal.vue?vue&type=script&lang=ts&"
export * from "./AddOrEditProviderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa57f1",
  null
  
)

export default component.exports